var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtoSecurity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3780_6568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C15.2696 0 15.5391 0.0585938 15.7852 0.169922L26.8184 4.85156C28.1075 5.39648 29.0684 6.66797 29.0625 8.20313C29.0332 14.0156 26.6426 24.6504 16.5469 29.4844C15.5684 29.9531 14.4317 29.9531 13.4532 29.4844C3.35745 24.6504 0.966824 14.0156 0.937527 8.20313C0.931667 6.66797 1.8926 5.39648 3.18167 4.85156L14.2207 0.169922C14.461 0.0585938 14.7305 0 15 0ZM15 3.91406V26.0684C23.086 22.1484 25.2598 13.4824 25.3125 8.28516L15 3.91406Z",
    fill: "#1565C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3780_6568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtoSecurity);
export default __webpack_public_path__ + "static/media/RTO-Security.2b9f7fe710f8ee5ff9760e406fa70e53.svg";
export { ForwardRef as ReactComponent };